// extracted by mini-css-extract-plugin
module.exports = {"root":"EditorsNote_root__YgiON","content":"EditorsNote_content__LgnZ7","label":"EditorsNote_label__dhNj_"};